// extracted by mini-css-extract-plugin
export default {"container":"AuthSimpleLayout_container__2a+Aj","logo":"AuthSimpleLayout_logo__70NUJ"};